import { Calendar, UserPlus, Receipt } from "lucide-react";
import { canAccess } from "@/lib/permissions";

const SERVICE_PROVIDER = new Set(["stylist", "therapist"]);

/** Daily front-desk ops only — full nav covers reports, settings, catalog, etc. */
export const QUICK_ACTIONS = [
    {
        id: "pos",
        label: "Bill customer",
        icon: Receipt,
        to: "/app/pos",
        perm: "pos",
        primary: true,
        when: (role) => !SERVICE_PROVIDER.has(role),
    },
    {
        id: "booking",
        label: "New booking",
        icon: Calendar,
        to: "/app/calendar?book=1",
        perm: "calendar",
        when: (role) => !SERVICE_PROVIDER.has(role),
    },
    {
        id: "calendar",
        label: "Calendar",
        icon: Calendar,
        to: "/app/calendar",
        perm: "calendar",
        primary: true,
        when: (role) => SERVICE_PROVIDER.has(role),
    },
    {
        id: "customer",
        label: "Add customer",
        icon: UserPlus,
        to: "/app/customers?new=1",
        perm: "customers",
        when: (role) => !SERVICE_PROVIDER.has(role),
    },
];

export function quickActionsForRole(role) {
    return QUICK_ACTIONS.filter((a) => {
        if (!canAccess(role, a.perm)) return false;
        if (a.when && !a.when(role)) return false;
        return true;
    });
}
